import React from "react";
import { Link } from "react-router-dom";
import { RiLayout3Fill } from "react-icons/ri";
import {
  MdEmail,
  MdReportProblem,
  MdAccountCircle,
  MdGroup,
} from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import "./settings-nav.css";

export const SettingsNav = (props) => {
  return (
    <div id="settings-nav-container">
      <ul id="settings-items">
        <li className="settings-item settings-item-first not-700px">
          <Link
            className="settings-item-link settings-item-first-link"
            to="/dashboard"
          >
            <IoMdClose className="settings-icon settings-item-first-icon" />
          </Link>
        </li>
        <li className="settings-item">
          <a
            className="settings-item-link"
            onClick={() => props.setActive("Account")}
          >
            <MdAccountCircle className="settings-icon" />
            <span className="settings-item-text">Account</span>
          </a>
        </li>
        <li className="settings-item">
          <a
            className="settings-item-link"
            onClick={() => props.setActive("Family")}
          >
            <MdGroup className="settings-icon" />
            <span className="settings-item-text">Family</span>
          </a>
        </li>
        <li className="settings-item">
          <a
            className="settings-item-link"
            onClick={() => props.setActive("Appearance")}
          >
            <RiLayout3Fill className="settings-icon" />
            <span className="settings-item-text">Appearance</span>
          </a>
        </li>
        <li className="settings-item settings-last-group not-700px">
          <a
            className="settings-item-link"
            onClick={() => props.setActive("Contact")}
          >
            <MdEmail className="settings-icon" />
            <span className="settings-item-text">Contact</span>
          </a>
        </li>
        <li className="settings-item not-700px">
          <a
            className="settings-item-link"
            onClick={() => props.setActive("Problem")}
          >
            <MdReportProblem className="settings-icon" />
            <span className="settings-item-text">Report</span>
          </a>
        </li>
      </ul>
    </div>
  );
};
